import React from 'react';
import ReactDOM from 'react-dom/client';
import { addSitePassword, captureAffiliateId } from '@link/share/utils';
import { initGDPRCookieBanner } from '@link/share/vendors';
import App from '@link/skytree/App';
import '@link/skytree/styles/index.css';
import '@link/skytree/i18n';
import '@link/skytree/vendors/gtm';

// Capture the affiliate tag from the entry URL first: anything below can
// replace the document or navigate, and the tag is read from session storage
// from here on.
captureAffiliateId();

// Enable password verification for 'testing' environment before React renders
const env = import.meta.env.VITE_APP_SKYTREE_ENV as string;
const requirePassword = ['testing'].includes(env);
addSitePassword(requirePassword);

// Show the Silktide Cookie Banner to GDPR-country visitors before React renders
initGDPRCookieBanner();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
